export default __webpack_public_path__ + "static/media/mw.78916c02.svg";